export default {
  BT_HDP: "Handicap | HDP",
  BT_OU: "Over/Under | O/U",
  BT_ML: "Moneyline",
  BT_1X2: "1X2",
  BT_1X2HDP: "3 Way Handicap",
  BT_CS: "Correct Score",
  BT_OE: "Odd/Even | O/E",
  BT_DC: "Double Chance",
  BT_HTFT: "Half Time/Full Time",
  BT_FGLG: "First Goal/Last Goal",
  BT_TG: "Total Goal",
  BT_OR: "Outright",
  BT_ORZ: "Outright",

  BT_ANB: "Away No Bet",
  BT_BS: "Both/One/Neither Team To Score",
  BT_CL: "Clean Sheet",
  BT_DNB: "Draw No Bet",
  BT_HNB: "Home No Bet",
  BT_TWTN: "To Win To Nil",

  BT_HDPF: "FT. Handicap | FT. HDP",
  BT_OUF: "FT. Over/Under | FT. O/U",
  BT_MLF: "FT. Moneyline",
  BT_1X2F: "FT. 1X2",
  BT_1X2HDPF: "FT. 3 Way Handicap",
  BT_CSF: "FT. Correct Score",
  BT_OEF: "FT. Odd/Even",
  BT_DCF: "FT. Double Chance",
  BT_FGLGF: "FT. First Goal/Last Goal",
  BT_TGF: "FT. Total Goal",

  BT_HDPH: "1H. Handicap | 1H. HDP",
  BT_OUH: "1H. Over/Under | 1H. O/U",
  BT_MLH: "1H. Moneyline",
  BT_1X2H: "1H. 1X2",
  BT_1X2HDPH: "1H. 3 Way Handicap",
  BT_CSH: "1H. Correct Score",
  BT_OEH: "1H. Odd/Even",
  BT_DCH: "1H. Double Chance",
  BT_FGLGH: "1H. First Goal/Last Goal",
  BT_TGH: "1H. Total Goal",

  BT_HDPOU: "HDP & OU",
  BT_PARLAY: "Mix Parlay",
  BT_FT: "FT. ",
  BT_1H: "1H. ",
  BT_2H: "2H. ",

  BT_FG: "First Goal",
  BT_LG: "Last Goal",
  BT_HFG: "HFG",
  BT_AFG: "AFG",
  BT_HLG: "HLG",
  BT_ALG: "ALG",
  BT_NG: "No Goal",
  BT_HY: "Home Yes",
  BT_HN: "Home No",
  BT_AY: "Away Yes",
  BT_AN: "Away No",
  BT_H: "Home",
  BT_A: "Away",
  BT_D: "Draw",
  BT_HD_DC: "HD",
  BT_HA_DC: "HA",
  BT_DA_DC: "DA",
  BT_HH: "HH",
  BT_HD: "HD",
  BT_HA: "HA",
  BT_DH: "DH",
  BT_DD: "DD",
  BT_DA: "DA",
  BT_AH: "AH",
  BT_AD: "AD",
  BT_AA: "AA",

  BT_Y: "Yes",
  BT_N: "No",

  BT_LIVE: "LIVE",
  BT_HT: "H.TIME",
  BT_DELAYED: "DELAY",
  BT_PEN: "PEN",

  BT_FT1: "FT.1",
  BT_FT2: "FT.2",
  BT_FTX: "FT.X",
  BT_HT1: "HT.1",
  BT_HT2: "HT.2",
  BT_HTX: "HT.X",

  BT_BOTH: "Both",
  BT_ONE: "One",
  
  LOT_BS: "B/S",
  LOT_BIG: "B",
  LOT_SMALL: "S",
  LOT_OE: "O/E",
  LOT_ODD: "O",
  LOT_EVEN: "E",
  LOT_OU: "O/U",
  LOT_OVER: "O",
  LOT_UNDER: "U",

  BT_ALL: "@:ui.bet_list",

  D_1: "Single Number",
  D_2: "Number & Reverse",
  D_3: "Box",
  D_4: "iBox",
  D_5: "Box Last 3 Digit",
  D_6: "Box Last 2 Digit",

  D_BIG: "BIG",
  D_SMALL: "SMALL",
  D_AA: "AA",
  D_SA: "3A",
  D_SB: "B",
  D_SC: "C",
  D_SD: "D",
  D_SE: "E",
  D_ABC: "3C",

  BT_HDPMMO: "HDPMMO",
  BT_OUMMO: "OUMMO",

  BT_OEHM: "Home Odd/Even | Home O/E",
  BT_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BT_OEAW: "Away Odd/Even | Away O/E",
  BT_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  BS_OEHM: "FT. Home Odd/Even | FT. Home O/E",
  BS_OEHMH: "FH. Home Odd/Even | FH. Home O/E",
  BS_OEAW: "FT. Away Odd/Even | FT. Away O/E",
  BS_OEAWH: "FH. Away Odd/Even | FH. Away O/E",

  MB_OVER: "OVER (4,5,6)",
  MB_UNDER: "UNDER (1,2,3)",
  MB_ODD: "ODD (1,3,5)",
  MB_EVEN: "EVEN (2,4,6)",

  BS_1X2OU: "1X2 + OU",
  BT_1X2OU: "1X2 + OU",
  BT_1O: "1O",
  BT_1U: "1U",
  BT_2O: "2O",
  BT_2U: "2U",
  BT_XO: "XO",
  BT_XU: "XU",

  BS_DCOU: "Double Chance + OU",
  BT_DCOU: "Double Chance + OU",
  BT_HDO: "HDO",
  BT_HDU: "HDU",
  BT_HAO: "HAO",
  BT_HAU: "HAU",
  BT_DAO: "DAO",
  BT_DAU: "DAU",

  BS_OUOE: "OU + OE",
  BT_OUOE: "OU + OE",
  BK_OO: "OO",
  BK_OE: "OE",
  BK_UO: "UO",
  BK_UE: "UE",

  BS_HTFTOE: "HT/FT + OE",
  BT_HTFTOE: "HT/FT + OE",
  BK_EO: "EO",
  BK_EE: "EE",

  BS_WM: "Winning Margin",
  BT_WM: "Winning Margin",
  BK_H1: "Home 1",
  BK_H2: "Home 2",
  BK_H3Up: "Home 3+",
  BK_A1: "Away 1",
  BK_A2: "Away 2",
  BK_A3Up: "Away 3+",
  BK_D: "Score Draw (Excl. 0-0)",
  BK_NG: "No Goal",

  BS_ETG: "Exact Total Goal",
  BT_ETG: "Exact Total Goal",
  BS_EHTG: "Exact Home Total Goal",
  BT_EHTG: "Exact Home Total Goal",
  BS_EATG: "Exact Away Total Goal",
  BT_EATG: "Exact Away Total Goal",
  BS_ETGH: "FH. Exact Total Goal",
  BT_ETGH: "FH. Exact Total Goal",
  BS_EHTGH: "FH. Exact Home Total Goal",
  BT_EHTGH: "FH. Exact Home Total Goal",
  BS_EATGH: "FH. Exact Away Total Goal",
  BT_EATGH: "FH. Exact Away Total Goal",
  BT_0: "0",
  BT_1: "1",
  BT_2: "2",
  BT_3: "3",
  BT_4: "4",
  BT_5: "5",
  BT_6Up: "6+",
  BT_3Up: "3+",

  BT_CSHTFT: "HT/FT Correct Score",
  BS_CSHTFT: "HT/FT Correct Score",
  BT_ETGHTFT: "HT/FT Exact Total Goal",
  BS_ETGHTFT: "HT/FT Exact Total Goal",

  MBR_SINGLE: "Single",
  MBR_TRIPS: "Trips",
  MBR_PAIR: "Pair",
};